import React from 'react';

import { SurveyEditorSidebarTabEnum } from '@/modules/corporate/modules/survey/views/SurveyEditor/components/SurveyEditorSidebar/types';

import SurveyFieldSettings from '../SurveyFieldSettings';
import SurveySettings from '../SurveySettings';
import { SurveyEditorSidebarContentProps } from './types';

function SurveyEditorSidebarContent(props: SurveyEditorSidebarContentProps) {
  const { activeTab } = props;

  switch (activeTab) {
    case SurveyEditorSidebarTabEnum.SurveySettings: {
      return <SurveySettings />;
    }
    case SurveyEditorSidebarTabEnum.FieldSettings: {
      return <SurveyFieldSettings />;
    }
    default: {
      return null;
    }
  }
}

export default SurveyEditorSidebarContent;
